module.exports = __webpack_public_path__ + "static/img/main-preview-burn-doc.bddd8eb0.svg";